import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Login.css";
import DialogoLoading from "../Components/DialogoLoading";
import Swal from "sweetalert2";
import DataService from "../IndexBD/DataService";
import { useAuth } from "../Auth/AuthContext";
import axios from "axios";
import GlobalFunctions from "../Services/GlobalFunctions";

const Login = () => {
  const glob = new GlobalFunctions();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [intentoSesion, setIntentoSesion] = useState(0);
  const { login } = useAuth();
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    if (intentoSesion == 4) {
      const array = [];
      array.push("bloqueo");
      //Bloquear por exceso de intentos fallidos de inicio de ssesion
      DataService.saveData("bloqueo", array);
      window.location.href = "https://cafemom.com/";
    }
  }, [intentoSesion]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    document.getElementById("btnOpenModalLoading").click();
    try {
      const loguear = await login(email, password);
      if (loguear.access_token) {
        //Guardar cookie para luego validar si se muestra el dialogo descargar clientes.
        glob.setCookie("session", true, 3600 * 24 * 30);
        setEmail("");
        setPassword("");
         // Envio correo alerta inicio sesion
        fetchAlertaInicioSesion();
      }
      document.getElementById("btnCloseModalLoading").click();
    } catch (error) {
       // Envio correo alerta inicio sesion
      fetchAlertaInicioSesion();
      document.getElementById("btnCloseModalLoading").click();
      let sumarIntento = intentoSesion + 1;
      setIntentoSesion(sumarIntento);
      sweetAlert(
        "Email o contraseña incorrectos! Intento de logueo n° " +
          intentoSesion +
          " de 4 para bloqueo!",
        "info"
      );
    }
  };

  function fetchAlertaInicioSesion() {
    const url =API_URL + "/loginwarningemail"
    axios
      .post(url, {
        emailAdmin: process.env.REACT_APP_EMAIL_ADMIN,
        emailUser: email,
        fecha: new Date().toLocaleString(),
      })
      .then((response) => {
      })
      .catch((error) => {
      });
  }

  function sweetAlert(mensaje, icono) {
    Swal.fire({
      title: mensaje,
      icon: icono,
      timer: 2000,
    });
  }

  return (
    <div className="login-container d-flex justify-content-center align-items-center vh-100">
      <DialogoLoading></DialogoLoading>
      <div className="card shadow-lg p-4 login-card">
        <div className="card-body">
          <h2 className="card-title text-center mb-4">Iniciar Sesión</h2>
          <form onSubmit={handleSubmit}>
            <div style={{ textAlign: "left" }} className="mb-3">
              <label htmlFor="emailInput" className="form-label">
                Correo Electrónico
              </label>
              <input
                type="email"
                className="form-control"
                id="emailInput"
                placeholder="tu@ejemplo.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div style={{ textAlign: "left" }} className="mb-3">
              <label htmlFor="passwordInput" className="form-label">
                Contraseña
              </label>
              <input
                type="password"
                className="form-control"
                id="passwordInput"
                placeholder="********"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <div className="d-grid gap-2 mb-3">
              <button type="submit" className="btn btn-primary btn-lg">
                Ingresar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
